var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.781,
    height: 21.734,
    viewBox: "0 0 19.781 21.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    transform: "translate(-2062.865 -863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    d: "M2072.4 873.935a5.467 5.467 0 1 0-5.467-5.467 5.473 5.473 0 0 0 5.467 5.467zm0-8.659a3.192 3.192 0 1 1-3.192 3.192 3.2 3.2 0 0 1 3.192-3.192z",
    className: "cls-1",
    transform: "translate(0.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    d: "M2064.007 883.795a1.135 1.135 0 0 0 1.126-.989 7.687 7.687 0 0 1 15.246 0 1.137 1.137 0 0 0 1.128.989 1.138 1.138 0 0 0 1.129-1.282 9.965 9.965 0 0 0-19.763.005 1.137 1.137 0 0 0 1.13 1.277z",
    className: "cls-1",
    transform: "translate(0 0.94)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5d5e34c9.svg";
export { ForwardRef as ReactComponent };